var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    style: {
      fill: "#FF4B55"
    },
    width: 256,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 256,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M114.333,31.439V67.49c1.985,0.078,4.2,0.979,6.041,2.82s2.743,4.056,2.82,6.041h36.052v35.93  h-36.052c-0.078,1.985-0.979,4.2-2.82,6.041c-1.84,1.841-4.055,2.742-6.041,2.82v36.052h-35.93v-36.052  c-1.985-0.077-4.2-0.979-6.041-2.82c-1.841-1.84-2.742-4.055-2.82-6.041H33.491v-35.93h36.052c0.077-1.985,0.979-4.2,2.82-6.041  c1.84-1.84,4.055-2.742,6.041-2.82V31.439H114.333 M118.825,26.947h-4.491h-35.93h-4.491v4.491v32.515  c-1.715,0.703-3.323,1.778-4.725,3.18c-1.402,1.403-2.478,3.011-3.181,4.726H33.491H29v4.491v35.93v4.491h4.491h32.515  c0.703,1.715,1.779,3.324,3.181,4.726s3.01,2.477,4.725,3.18v32.515v4.491h4.491h35.93h4.491v-4.491v-32.515  c1.715-0.703,3.324-1.779,4.726-3.181c1.402-1.401,2.477-3.01,3.18-4.725h32.515h4.491v-4.491V76.35v-4.49h-4.491H126.73  c-0.703-1.715-1.779-3.323-3.181-4.726c-1.402-1.402-3.01-2.477-4.725-3.18V31.439L118.825,26.947L118.825,26.947z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CDCDCD"
    },
    points: "159.246,76.351 114.333,76.351 114.333,31.439 78.404,31.439 78.404,76.351 33.491,76.351   33.491,112.281 78.404,112.281 78.404,157.193 114.333,157.193 114.333,112.281 159.246,112.281 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B4A08C"
    },
    cx: 96.37,
    cy: 94.32,
    r: 17.965
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 49.3956 249.2048)",
    style: {
      fill: "#B4A08C"
    },
    cx: 76.31,
    cy: 114.372,
    rx: 7.989,
    ry: 5.592
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -46.773 115.8191)",
    style: {
      fill: "#B4A08C"
    },
    cx: 116.42,
    cy: 114.37,
    rx: 7.989,
    ry: 5.592
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 86.6194 -60.5691)",
    style: {
      fill: "#B4A08C"
    },
    cx: 116.423,
    cy: 74.274,
    rx: 7.989,
    ry: 5.592
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 182.8054 72.8235)",
    style: {
      fill: "#B4A08C"
    },
    cx: 76.32,
    cy: 74.272,
    rx: 7.989,
    ry: 5.592
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B4A08C"
    },
    d: "M96.368,118.908c-13.561,0-24.592-11.031-24.592-24.592s11.031-24.592,24.592-24.592   s24.592,11.031,24.592,24.592S109.93,118.908,96.368,118.908z M96.368,71.969c-12.32,0-22.346,10.026-22.346,22.346   s10.026,22.346,22.346,22.346s22.346-10.026,22.346-22.346S108.689,71.969,96.368,71.969z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.b3ebb8225a5567b070c0d864595088b6.svg";
export { ForwardRef as ReactComponent };